"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleStringHash = void 0;

/**
 * Mimics the hash implementation done on Android and iOS for determining fall
 * back images, etc.
 * Two inputs with same contents but different order will return the same value.
 * If you care about collisions, use `hash` below :)
 *
 * @param  {string} input String to be hashed per android and ios implementation
 * @return {string} hash of string input
 */
var simpleStringHash = function simpleStringHash(input) {
  var hash = 0;

  if (!input) {
    return hash.toString();
  }

  return input.split('').reduce(function (memo, char) {
    return memo + char.charCodeAt(0);
  }, hash).toString();
};

exports.simpleStringHash = simpleStringHash;
//# sourceMappingURL=simple-string-hash.js.map